export const footer = {
  "description": "A plataforma de troca de casas entre anfitriões Airbnb. Viaje gratuitamente em todo o mundo.",
  "company": "Empresa",
  "about": "Sobre",
  "howItWorks": "Como funciona",
  "blog": "Blog",
  "careers": "Carreiras",
  "support": "Suporte",
  "help": "Centro de ajuda",
  "contact": "Contato",
  "terms": "Termos de uso",
  "privacy": "Privacidade",
  "community": "Comunidade",
  "members": "Membros",
  "destinations": "Destinos",
  "events": "Eventos",
  "newsletter": "Boletim informativo",
  "newsletterText": "Receba nossas últimas ofertas e novidades",
  "emailPlaceholder": "Seu email",
  "newsletterSuccess": "Inscrição realizada!",
  "newsletterError": "Ocorreu um erro.",
  "newsletterInvalid": "Email inválido.",
  "subscribe": "Inscrever-se",
  "rights": "Todos os direitos reservados",
  "madeWith": "Feito com",
  "by": "pela equipe DONKEY TRAVEL"
};
